import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

new Swiper(".videos-swiper__container", {
	spaceBetween: 0,
	slidesPerView: 1.11,
	centeredSlides: true,
	roundLengths: true,
	loop: true,
	draggable: true,
	modules: [Navigation, Pagination],
	navigation: {
		nextEl: ".videos-swiper-button-next",
		prevEl: ".videos-swiper-button-prev"
	},
	pagination: {
		el: ".videos-swiper-pagination",
		type: "fraction",
		clickable: true
	},
	breakpoints: {
		768: {
			slidesPerView: 1.48,
			spaceBetween: 0,
		},
	},
});

const body = document?.querySelector('body');
const playButtons = document?.querySelectorAll('.video-play-button');
const closeButtons = document?.querySelectorAll('.swiper-close-vimeo-modal');

const players = {};
const playerIdentifiers = new Set();

const toggleOpenCloseSwiperVideo = (currentPlayer) => {
	const { videoContainer, player } = currentPlayer || {};
	body?.classList?.toggle('overflow');
	videoContainer?.classList?.toggle('active');

	player?.getPaused()?.then(() => {
		if(videoContainer?.classList?.contains('active')) {
			player?.play();
			player?.setMuted(false);
		}
		else {
			player?.setMuted(true);
			player?.pause();
		}
	});
};


if(playButtons?.length > 0) {
	for (let i=0; i<playButtons.length; i++) {
		const playerIdentifier = playButtons[i]?.dataset?.playerId;
		playerIdentifiers.add(playerIdentifier);
	}

	if(playerIdentifiers?.size > 0) {
		playerIdentifiers.forEach((playerIdentifier) => {
			const iframe = document.getElementById(playerIdentifier);
			const videoContainer = iframe?.closest('.swiper-vimeo-custom-video');
			players[playerIdentifier] = {videoContainer: videoContainer, player: new Vimeo.Player(iframe)};
		});
	}

	for (let i=0; i<playButtons.length; i++) {
		const playerIdentifier = playButtons[i]?.dataset?.playerId;
		playButtons[i].addEventListener('click', () => toggleOpenCloseSwiperVideo(players[playerIdentifier]));
	}
}

if(closeButtons?.length > 0 ) {
	for (let i=0; i<closeButtons.length; i++) {
		const playerIdentifier = closeButtons[i]?.dataset?.playerId;
		closeButtons[i].addEventListener('click', () => toggleOpenCloseSwiperVideo(players[playerIdentifier]));
	}
}
